import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut, FiGlobe } from 'react-icons/fi';

function Layout({ children }) {
  const navigate = useNavigate();
  const username = localStorage.getItem('username');

  const handleLogout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    navigate('/login');
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <h1 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
              <FiGlobe style={{ marginRight: '0.5rem', verticalAlign: 'middle' }} />
              Clehance Lingua
            </h1>
            <div className="user-info">
              <span>Welcome, {username}</span>
              <button className="btn btn-light" onClick={handleLogout}>
                <FiLogOut />
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className="container" style={{ marginTop: '2rem', minHeight: 'calc(100vh - 100px)' }}>
        {children}
      </main>
    </>
  );
}

export default Layout; 